/**
 * Front-end script for Waarom Houtman & Stappen Block
 */

document.addEventListener( 'DOMContentLoaded', () => {
	// IntersectionObserver for smooth entrance animation if desired
	const stepItems = document.querySelectorAll( '.wi-step-item, .wi-step-badge' );
	if ( 'IntersectionObserver' in window ) {
		const observer = new IntersectionObserver(
			( entries ) => {
				entries.forEach( ( entry ) => {
					if ( entry.isIntersecting ) {
						entry.target.classList.add( 'is-visible' );
					}
				} );
			},
			{ threshold: 0.2 }
		);

		stepItems.forEach( ( item ) => observer.observe( item ) );
	}
} );
